
const emptyWhale = {
  whaleId: "",
  whaleName: "",
  whaleType: "",
  is_escort: "",
  bhv: [],
  groupNumber: "",
  groupMemberId: "",
  groupSize: "",
  totalBnf: "",
  scarSequence: "",
  joinTime: "",
  isiSpecies: "",
  features: [{ featureName: "", photoNumber: "" }],
}

const state = {
  isDialogOpen: false,
  isListed: false,
  whale: {},
  isSaving: false,
};

const getters = {
  dialog: (state) => state.isDialogOpen,
  button: () => ("Save"),
  title: (state) =>
    state.whale && state.whale.whaleId
      ? `Edit Whale ${state.whale.whaleName}`
      : "Create New Whale",
  whale: (state) => state.whale,
  saving: (state) => state.isSaving,
};

const actions = {
  open({ commit }, whale) {
    commit("open", { whale });
  },
  close({ commit }) {
    commit("close");
  },
  resetSaving({ commit }) {
    commit("saving", false)
  },
};

const mutations = {
  open(state, { whale }) {
    state.isSaving = false;
    if(!whale) {
      state.whale = JSON.parse(JSON.stringify(emptyWhale));
    }
    else {
      state.whale = JSON.parse(JSON.stringify(whale));
    }
    state.isDialogOpen = true;
  },
  close(state) {
    state.isDialogOpen = false;
    // todo: need to store whale obj somewhere else if we blank it on close
    state.whale = JSON.parse(JSON.stringify(emptyWhale));
    state.specOtherValue = "";
    state.incOtherValue = "";
    state.locOtherValue = "";
    state.isSaving = false;
  },
  saving(state, isSaving) {
    state.isSaving = isSaving;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
